import { isNil } from 'lodash';
import { z } from 'zod';

export const EmailSchema = z.email();

export type Email = z.infer<typeof EmailSchema>;

/**
 * Verifies if the provided email is a valid email address
 * @returns true if valid, false otherwise.
 */
export function isValidEmail(email: string | null | undefined): boolean {
  if (isNil(email)) {
    return false;
  }

  return EmailSchema.safeParse(email).success;
}
